import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories, categoryColorMap } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);
  const filteredArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-16 flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-4">
              分类未找到
            </h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const colors = categoryColorMap[category.color] || { bg: 'bg-primary-100', text: 'text-primary-700', badge: 'bg-primary-500' };

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="min-h-screen pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />

          <section className="py-6 md:py-10">
            <div className="text-center mb-8">
              <span className={`inline-block w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full ${colors.bg} ${colors.text} mb-4`}>
                <i className={`${category.icon} text-2xl`}></i>
              </span>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                {category.name}
              </h1>
              <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
                {category.description}
              </p>
            </div>

            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-200 text-foreground-400">
                  <i className="ri-inbox-line text-2xl"></i>
                </div>
                <p className="text-foreground-600">该分类下暂无文章</p>
              </div>
            )}
          </section>

          <section className="pb-10 md:pb-14">
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-5">
              浏览其他分类
            </h2>
            <div className="flex flex-wrap gap-2">
              {categories
                .filter((c) => c.slug !== slug)
                .map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="px-4 py-2 rounded-lg text-sm font-medium bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}